import { Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

import { Button } from '@/components/ui/button';

/**
 * Toggle dark ↔ light persistido por next-themes en localStorage.
 *
 * Renderizamos un placeholder en SSR/primer paint para evitar hydration
 * mismatch (next-themes recomienda este patrón).
 */
export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Patrón oficial de next-themes para evitar hydration mismatch:
  // el primer render no conoce el theme persistido. El setState de
  // useEffect post-mount es intencional, no un anti-pattern.
  // eslint-disable-next-line react-hooks/set-state-in-effect
  useEffect(() => setMounted(true), []);

  const isDark = resolvedTheme === 'dark';

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label={isDark ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
      title={isDark ? 'Tema claro (T)' : 'Tema oscuro (T)'}
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className="text-fg-muted hover:text-fg h-9 w-9 shrink-0"
    >
      {mounted ? (
        isDark ? (
          <Sun className="h-4 w-4" />
        ) : (
          <Moon className="h-4 w-4" />
        )
      ) : (
        <span className="block h-4 w-4" aria-hidden />
      )}
    </Button>
  );
}
